export const toRelayId = (node: string, id: string | number): string => btoa(`${node}:${id}`);
